import type { AssistantUsage } from "catchment-common/interfaces/llmQuery";

export type ContextUsage = {
  inputTokens: number;
  outputTokens: number;
  percentage: number;
};

// Fallback only for legacy usage payloads persisted before the backend started
// sending `contextWindow`. The server now always supplies the active model's
// real window, so this is a last resort — kept large (matching the current
// gpt-5* window) so a missing value under-reports rather than over-reports.
const FALLBACK_CONTEXT_TOKENS = 400_000;

// Convert raw token usage into a context-fullness percentage. The denominator
// is the model's actual context window (sent by the backend) — never a
// hardcoded guess, which is what made the gauge fill several times too fast.
export const toContextUsage = (
  u?: AssistantUsage
): ContextUsage | undefined => {
  if (!u) return undefined;
  const window = u.contextWindow ?? FALLBACK_CONTEXT_TOKENS;
  return {
    inputTokens: u.inputTokens,
    outputTokens: u.outputTokens,
    percentage: Math.min(100, ((u.inputTokens + u.outputTokens) / window) * 100)
  };
};
